module.exports = __webpack_public_path__ + "img/6479035.01204615.jpg";